export enum CountriesEnum
{
    BE = "Belgium",
    IT = "Italy",
    NL = "Netherlands",
    US = "USA",
    CA = "Canada",
    CH = "Switzerland",
    IE = "Republic of Ireland",
    LU = "Luxembourg",
    UV = "Veteran’s Administration",
    GB = "Great Britain"
}
